import { render } from "./Valfler.vue?vue&type=template&id=47b16f59"
import script from "./Valfler.vue?vue&type=script&lang=js"
export * from "./Valfler.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__